/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeOrbShopCatalogResponse,
  ApiEnvelopeOrbsSellConfigListResponse,
  ApiEnvelopeOrbsTraderConfigCreatedResponse,
  ApiEnvelopeOrbsTraderConfigListResponse,
  ApiEnvelopeOrbsTraderEmptyResponse,
  ApiEnvelopeOrbsTraderRunResponse,
  OrbsSellConfigInputDto,
  OrbsTraderConfigInputDto,
  OrbsTraderStopOrbsSellParams,
  OrbsTraderStopOrbsTraderParams,
  RunOrbsTraderRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type orbsTraderGetOrbShopCatalogResponse200 = {
  data: ApiEnvelopeOrbShopCatalogResponse
  status: 200
}

export type orbsTraderGetOrbShopCatalogResponseSuccess = (orbsTraderGetOrbShopCatalogResponse200) & {
  headers: Headers;
};
;

export type orbsTraderGetOrbShopCatalogResponse = (orbsTraderGetOrbShopCatalogResponseSuccess)

export const getOrbsTraderGetOrbShopCatalogUrl = () => {




  return `/api/OrbsTrader/catalog`
}

export const useOrbsTraderGetOrbShopCatalogHook = (): ( options?: RequestInit) => Promise<orbsTraderGetOrbShopCatalogResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getOrbsTraderGetOrbShopCatalogUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type orbsTraderGetOrbsTraderConfigsResponse200 = {
  data: ApiEnvelopeOrbsTraderConfigListResponse
  status: 200
}

export type orbsTraderGetOrbsTraderConfigsResponseSuccess = (orbsTraderGetOrbsTraderConfigsResponse200) & {
  headers: Headers;
};
;

export type orbsTraderGetOrbsTraderConfigsResponse = (orbsTraderGetOrbsTraderConfigsResponseSuccess)

export const getOrbsTraderGetOrbsTraderConfigsUrl = () => {




  return `/api/OrbsTrader`
}

export const useOrbsTraderGetOrbsTraderConfigsHook = (): ( options?: RequestInit) => Promise<orbsTraderGetOrbsTraderConfigsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getOrbsTraderGetOrbsTraderConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type orbsTraderCreateOrbsTraderConfigResponse200 = {
  data: ApiEnvelopeOrbsTraderConfigCreatedResponse
  status: 200
}

export type orbsTraderCreateOrbsTraderConfigResponse400 = {
  data: ApiEnvelopeOrbsTraderConfigCreatedResponse
  status: 400
}

export type orbsTraderCreateOrbsTraderConfigResponseSuccess = (orbsTraderCreateOrbsTraderConfigResponse200) & {
  headers: Headers;
};
export type orbsTraderCreateOrbsTraderConfigResponseError = (orbsTraderCreateOrbsTraderConfigResponse400) & {
  headers: Headers;
};

export type orbsTraderCreateOrbsTraderConfigResponse = (orbsTraderCreateOrbsTraderConfigResponseSuccess | orbsTraderCreateOrbsTraderConfigResponseError)

export const getOrbsTraderCreateOrbsTraderConfigUrl = () => {




  return `/api/OrbsTrader`
}

export const useOrbsTraderCreateOrbsTraderConfigHook = (): (orbsTraderConfigInputDto?: OrbsTraderConfigInputDto, options?: RequestInit) => Promise<orbsTraderCreateOrbsTraderConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (orbsTraderConfigInputDto?: OrbsTraderConfigInputDto, options?: RequestInit) => {

        return customFetcher(getOrbsTraderCreateOrbsTraderConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orbsTraderConfigInputDto)
  }
);
      }
  }


export type orbsTraderUpdateOrbsTraderConfigResponse200 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 200
}

export type orbsTraderUpdateOrbsTraderConfigResponse400 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 400
}

export type orbsTraderUpdateOrbsTraderConfigResponse404 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 404
}

export type orbsTraderUpdateOrbsTraderConfigResponseSuccess = (orbsTraderUpdateOrbsTraderConfigResponse200) & {
  headers: Headers;
};
export type orbsTraderUpdateOrbsTraderConfigResponseError = (orbsTraderUpdateOrbsTraderConfigResponse400 | orbsTraderUpdateOrbsTraderConfigResponse404) & {
  headers: Headers;
};

export type orbsTraderUpdateOrbsTraderConfigResponse = (orbsTraderUpdateOrbsTraderConfigResponseSuccess | orbsTraderUpdateOrbsTraderConfigResponseError)

export const getOrbsTraderUpdateOrbsTraderConfigUrl = (id: string,) => {




  return `/api/OrbsTrader/${id}`
}

export const useOrbsTraderUpdateOrbsTraderConfigHook = (): (id: string,
    orbsTraderConfigInputDto?: OrbsTraderConfigInputDto, options?: RequestInit) => Promise<orbsTraderUpdateOrbsTraderConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    orbsTraderConfigInputDto?: OrbsTraderConfigInputDto, options?: RequestInit) => {

        return customFetcher(getOrbsTraderUpdateOrbsTraderConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orbsTraderConfigInputDto)
  }
);
      }
  }


export type orbsTraderDeleteOrbsTraderConfigResponse200 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 200
}

export type orbsTraderDeleteOrbsTraderConfigResponse404 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 404
}

export type orbsTraderDeleteOrbsTraderConfigResponseSuccess = (orbsTraderDeleteOrbsTraderConfigResponse200) & {
  headers: Headers;
};
export type orbsTraderDeleteOrbsTraderConfigResponseError = (orbsTraderDeleteOrbsTraderConfigResponse404) & {
  headers: Headers;
};

export type orbsTraderDeleteOrbsTraderConfigResponse = (orbsTraderDeleteOrbsTraderConfigResponseSuccess | orbsTraderDeleteOrbsTraderConfigResponseError)

export const getOrbsTraderDeleteOrbsTraderConfigUrl = (id: string,) => {




  return `/api/OrbsTrader/${id}`
}

export const useOrbsTraderDeleteOrbsTraderConfigHook = (): (id: string, options?: RequestInit) => Promise<orbsTraderDeleteOrbsTraderConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getOrbsTraderDeleteOrbsTraderConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type orbsTraderRunOrbsTraderConfigResponse200 = {
  data: ApiEnvelopeOrbsTraderRunResponse
  status: 200
}

export type orbsTraderRunOrbsTraderConfigResponse400 = {
  data: ApiEnvelopeOrbsTraderRunResponse
  status: 400
}

export type orbsTraderRunOrbsTraderConfigResponse404 = {
  data: ApiEnvelopeOrbsTraderRunResponse
  status: 404
}

export type orbsTraderRunOrbsTraderConfigResponseSuccess = (orbsTraderRunOrbsTraderConfigResponse200) & {
  headers: Headers;
};
export type orbsTraderRunOrbsTraderConfigResponseError = (orbsTraderRunOrbsTraderConfigResponse400 | orbsTraderRunOrbsTraderConfigResponse404) & {
  headers: Headers;
};

export type orbsTraderRunOrbsTraderConfigResponse = (orbsTraderRunOrbsTraderConfigResponseSuccess | orbsTraderRunOrbsTraderConfigResponseError)

export const getOrbsTraderRunOrbsTraderConfigUrl = (id: string,) => {




  return `/api/OrbsTrader/${id}/run`
}

export const useOrbsTraderRunOrbsTraderConfigHook = (): (id: string,
    runOrbsTraderRequest?: RunOrbsTraderRequest, options?: RequestInit) => Promise<orbsTraderRunOrbsTraderConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runOrbsTraderRequest?: RunOrbsTraderRequest, options?: RequestInit) => {

        return customFetcher(getOrbsTraderRunOrbsTraderConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runOrbsTraderRequest)
  }
);
      }
  }


export type orbsTraderStopOrbsTraderResponse200 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 200
}

export type orbsTraderStopOrbsTraderResponse404 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 404
}

export type orbsTraderStopOrbsTraderResponseSuccess = (orbsTraderStopOrbsTraderResponse200) & {
  headers: Headers;
};
export type orbsTraderStopOrbsTraderResponseError = (orbsTraderStopOrbsTraderResponse404) & {
  headers: Headers;
};

export type orbsTraderStopOrbsTraderResponse = (orbsTraderStopOrbsTraderResponseSuccess | orbsTraderStopOrbsTraderResponseError)

export const getOrbsTraderStopOrbsTraderUrl = (id: string,
    params?: OrbsTraderStopOrbsTraderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/OrbsTrader/${id}/stop?${stringifiedParams}` : `/api/OrbsTrader/${id}/stop`
}

export const useOrbsTraderStopOrbsTraderHook = (): (id: string,
    params?: OrbsTraderStopOrbsTraderParams, options?: RequestInit) => Promise<orbsTraderStopOrbsTraderResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: OrbsTraderStopOrbsTraderParams, options?: RequestInit) => {

        return customFetcher(getOrbsTraderStopOrbsTraderUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type orbsTraderGetOrbsSellConfigsResponse200 = {
  data: ApiEnvelopeOrbsSellConfigListResponse
  status: 200
}

export type orbsTraderGetOrbsSellConfigsResponseSuccess = (orbsTraderGetOrbsSellConfigsResponse200) & {
  headers: Headers;
};
;

export type orbsTraderGetOrbsSellConfigsResponse = (orbsTraderGetOrbsSellConfigsResponseSuccess)

export const getOrbsTraderGetOrbsSellConfigsUrl = () => {




  return `/api/OrbsTrader/sell`
}

export const useOrbsTraderGetOrbsSellConfigsHook = (): ( options?: RequestInit) => Promise<orbsTraderGetOrbsSellConfigsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getOrbsTraderGetOrbsSellConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type orbsTraderCreateOrbsSellConfigResponse200 = {
  data: ApiEnvelopeOrbsTraderConfigCreatedResponse
  status: 200
}

export type orbsTraderCreateOrbsSellConfigResponse400 = {
  data: ApiEnvelopeOrbsTraderConfigCreatedResponse
  status: 400
}

export type orbsTraderCreateOrbsSellConfigResponseSuccess = (orbsTraderCreateOrbsSellConfigResponse200) & {
  headers: Headers;
};
export type orbsTraderCreateOrbsSellConfigResponseError = (orbsTraderCreateOrbsSellConfigResponse400) & {
  headers: Headers;
};

export type orbsTraderCreateOrbsSellConfigResponse = (orbsTraderCreateOrbsSellConfigResponseSuccess | orbsTraderCreateOrbsSellConfigResponseError)

export const getOrbsTraderCreateOrbsSellConfigUrl = () => {




  return `/api/OrbsTrader/sell`
}

export const useOrbsTraderCreateOrbsSellConfigHook = (): (orbsSellConfigInputDto?: OrbsSellConfigInputDto, options?: RequestInit) => Promise<orbsTraderCreateOrbsSellConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (orbsSellConfigInputDto?: OrbsSellConfigInputDto, options?: RequestInit) => {

        return customFetcher(getOrbsTraderCreateOrbsSellConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orbsSellConfigInputDto)
  }
);
      }
  }


export type orbsTraderUpdateOrbsSellConfigResponse200 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 200
}

export type orbsTraderUpdateOrbsSellConfigResponse400 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 400
}

export type orbsTraderUpdateOrbsSellConfigResponse404 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 404
}

export type orbsTraderUpdateOrbsSellConfigResponseSuccess = (orbsTraderUpdateOrbsSellConfigResponse200) & {
  headers: Headers;
};
export type orbsTraderUpdateOrbsSellConfigResponseError = (orbsTraderUpdateOrbsSellConfigResponse400 | orbsTraderUpdateOrbsSellConfigResponse404) & {
  headers: Headers;
};

export type orbsTraderUpdateOrbsSellConfigResponse = (orbsTraderUpdateOrbsSellConfigResponseSuccess | orbsTraderUpdateOrbsSellConfigResponseError)

export const getOrbsTraderUpdateOrbsSellConfigUrl = (id: string,) => {




  return `/api/OrbsTrader/sell/${id}`
}

export const useOrbsTraderUpdateOrbsSellConfigHook = (): (id: string,
    orbsSellConfigInputDto?: OrbsSellConfigInputDto, options?: RequestInit) => Promise<orbsTraderUpdateOrbsSellConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    orbsSellConfigInputDto?: OrbsSellConfigInputDto, options?: RequestInit) => {

        return customFetcher(getOrbsTraderUpdateOrbsSellConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orbsSellConfigInputDto)
  }
);
      }
  }


export type orbsTraderDeleteOrbsSellConfigResponse200 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 200
}

export type orbsTraderDeleteOrbsSellConfigResponse404 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 404
}

export type orbsTraderDeleteOrbsSellConfigResponseSuccess = (orbsTraderDeleteOrbsSellConfigResponse200) & {
  headers: Headers;
};
export type orbsTraderDeleteOrbsSellConfigResponseError = (orbsTraderDeleteOrbsSellConfigResponse404) & {
  headers: Headers;
};

export type orbsTraderDeleteOrbsSellConfigResponse = (orbsTraderDeleteOrbsSellConfigResponseSuccess | orbsTraderDeleteOrbsSellConfigResponseError)

export const getOrbsTraderDeleteOrbsSellConfigUrl = (id: string,) => {




  return `/api/OrbsTrader/sell/${id}`
}

export const useOrbsTraderDeleteOrbsSellConfigHook = (): (id: string, options?: RequestInit) => Promise<orbsTraderDeleteOrbsSellConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getOrbsTraderDeleteOrbsSellConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type orbsTraderRunOrbsSellConfigResponse200 = {
  data: ApiEnvelopeOrbsTraderRunResponse
  status: 200
}

export type orbsTraderRunOrbsSellConfigResponse400 = {
  data: ApiEnvelopeOrbsTraderRunResponse
  status: 400
}

export type orbsTraderRunOrbsSellConfigResponse404 = {
  data: ApiEnvelopeOrbsTraderRunResponse
  status: 404
}

export type orbsTraderRunOrbsSellConfigResponseSuccess = (orbsTraderRunOrbsSellConfigResponse200) & {
  headers: Headers;
};
export type orbsTraderRunOrbsSellConfigResponseError = (orbsTraderRunOrbsSellConfigResponse400 | orbsTraderRunOrbsSellConfigResponse404) & {
  headers: Headers;
};

export type orbsTraderRunOrbsSellConfigResponse = (orbsTraderRunOrbsSellConfigResponseSuccess | orbsTraderRunOrbsSellConfigResponseError)

export const getOrbsTraderRunOrbsSellConfigUrl = (id: string,) => {




  return `/api/OrbsTrader/sell/${id}/run`
}

export const useOrbsTraderRunOrbsSellConfigHook = (): (id: string,
    runOrbsTraderRequest?: RunOrbsTraderRequest, options?: RequestInit) => Promise<orbsTraderRunOrbsSellConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runOrbsTraderRequest?: RunOrbsTraderRequest, options?: RequestInit) => {

        return customFetcher(getOrbsTraderRunOrbsSellConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runOrbsTraderRequest)
  }
);
      }
  }


export type orbsTraderStopOrbsSellResponse200 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 200
}

export type orbsTraderStopOrbsSellResponse404 = {
  data: ApiEnvelopeOrbsTraderEmptyResponse
  status: 404
}

export type orbsTraderStopOrbsSellResponseSuccess = (orbsTraderStopOrbsSellResponse200) & {
  headers: Headers;
};
export type orbsTraderStopOrbsSellResponseError = (orbsTraderStopOrbsSellResponse404) & {
  headers: Headers;
};

export type orbsTraderStopOrbsSellResponse = (orbsTraderStopOrbsSellResponseSuccess | orbsTraderStopOrbsSellResponseError)

export const getOrbsTraderStopOrbsSellUrl = (id: string,
    params?: OrbsTraderStopOrbsSellParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/OrbsTrader/sell/${id}/stop?${stringifiedParams}` : `/api/OrbsTrader/sell/${id}/stop`
}

export const useOrbsTraderStopOrbsSellHook = (): (id: string,
    params?: OrbsTraderStopOrbsSellParams, options?: RequestInit) => Promise<orbsTraderStopOrbsSellResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: OrbsTraderStopOrbsSellParams, options?: RequestInit) => {

        return customFetcher(getOrbsTraderStopOrbsSellUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


